import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../authentication/services/auth.guard.service';
import { StorageComponent } from './components/scripts/storage.component';


const storageRoutes: Routes = [
 {
    path: 'storage', component: StorageComponent,
    canActivate: [AuthGuard],
    data: {
      roles: ['Admin', 'StorageManager']
    },
    children: [
      {
        path: '',
        children: [
          {
            path: 'filter',
            component: StorageComponent,
            data: { preload: true }
          }
        ]
      }
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(storageRoutes)
  ],
  exports: [
    RouterModule
  ]
})

export class StorageRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/storage/storage-routing.module.ts